import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { _AddCommercialCampaign, _CommercialCampaign, _CustomerAddress, _DistributionChannel, _SalesConsultant } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";



export const SalesConsultant = () => {

    const consult = useDataBean(_SalesConsultant);
    const paginador = usePaginator();
    const single = Singleton.getInstance();
    const [FunctionalID, setFunctionalID] = useState<number>(null)
    const [lista, setLista] = useState<any>([]);
    const [Account, setAccount] = useState<number>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const [modaladd, setModaladd] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        consult.instance.getSalesConsultantCatalog(Account, FunctionalID, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    // setLista(resp.List)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Client = (user.DataBeanProperties.AccountNit ?? "") + "Sin Tercero" + (user.DataBeanProperties.AccountName ?? "");
                        user.DataBeanProperties.Group = (user.DataBeanProperties.FunctionalIDJsonCode ?? "") + "Sin Grupo" + (user.DataBeanProperties.FunctionalIDName ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }
    const addDistributionChannelByAccount = () => {
        //console.log(entailment.bean);
        consult.instance.addSalesConsultant(consult.bean.IDAccount).then(
            (resp: any) => {
                getLista();
                setModaladd({ ...modaladd, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const create = () => {
        consult.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        consult.instance.deleteSalesConsultant(consult.bean.IDSalesConsultant).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        consult.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const veradd = () => {
        setModaladd({ ...modaladd, "view": true });

    }
    const head = [
        { title: 'ID', property: 'IDSalesConsultant', visible: true },
        { title: 'Tercero', property: 'Client', visible: true },
        { title: 'Grupo Organizacional', property: 'Group', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Desde', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Consultores de Venta">
            <div className="row">
                <div className="col-md-6">
                    <AccountEditor label="Tercero" idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }}></AccountEditor>
                </div>
                <div className="col-md-6">
                    <SelectFunctionalID label='Grupo Organizacional' functionalIDLn={FunctionalID} onChange={(e) => { setFunctionalID(e.IDLn) }} />
                </div>
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={veradd}>
                        Agregar Consultor de Ventas
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={consult.setBean} listButtons={listaBotones()} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={consult.bean.Name} onChange={consult.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <SelectFunctionalID label='Grupo Organizacional' functionalIDLn={consult.bean.IDLnFunctionalID} onChange={(e) => { consult.setBean({ ...consult.bean, "IDLnFunctionalID": e.IDLn }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <input type="text" name="Description" className="form-control" value={consult.bean.Description} onChange={consult.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modaladd} updateModal={setModaladd} eventModal={addDistributionChannelByAccount}>
                        <div className="row">
                            <div className="col-md-12">
                                <AccountEditor label="Tercero" idAccount={consult.bean.IDAccount} onChange={(e) => { consult.setBean({ ...consult.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {consult.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}